import {useI18n} from '@udemy/i18n';

import {CertificationAggregatorData} from '../../types';
import {SectionLayoutWrapper} from '../section-layout-wrapper/section-layout-wrapper.react-component';
import {CategoryNumberIcon} from '../topic-category/topic-category-menu.react-component';
import styles from './certification-preparation.module.less';
import {CertificationTopicCarousel} from './certification-topic-carousel.react-component';
import {RelatedCertificationAggregator} from './related-certification-aggregator.react-component';

export const CertPrepSection = ({
    aggregatorsData,
}: {
    aggregatorsData: CertificationAggregatorData | null;
}) => {
    const {gettext} = useI18n();
    const title = gettext('Certification Preparation');
    const subHeadline = gettext(
        'Prep for certifications with comprehensive courses, practice tests, and special offers on exam vouchers.',
    );
    const renderCertificationPreparationTitle = () => {
        return (
            <>
                <CategoryNumberIcon
                    number={2}
                    className={styles['certification-preparation-icon-desktop']}
                />
                <div className={styles['certification-preparation-title-content']}>
                    <h2 className={styles['certification-preparation-title-text']}>{title}</h2>
                    <p className={styles['certification-preparation-sub-headline']}>
                        {subHeadline}
                    </p>
                </div>
                <p className={styles['certification-preparation-sub-headline-mobile']}>
                    {subHeadline}
                </p>
            </>
        );
    };
    return (
        <SectionLayoutWrapper title={title} sectionNumber={2}>
            <section
                className={styles['certification-preparation-section']}
                id="certification-preparation"
            >
                <div className={styles['certification-preparation-title']}>
                    {renderCertificationPreparationTitle()}
                </div>
                {aggregatorsData && (
                    <div className={styles['certification-preparation-content']}>
                        <CertificationTopicCarousel
                            initialData={
                                aggregatorsData.certificationTopicCarouselComponentInitialData
                            }
                        />
                        <RelatedCertificationAggregator
                            initialData={aggregatorsData.relatedAggregatorsComponentInitialData}
                        />
                    </div>
                )}
            </section>
        </SectionLayoutWrapper>
    );
};
